module.exports = __webpack_public_path__ + "static/img/Bachelor_010471.7094f60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010471.jpg
// module id = 171
// module chunks = 0